/**
 * カート画面の配送先フォーム制御スクリプト
 * - チェックボックスのON/OFFで入力フォームの表示/非表示を切り替え
 * - チェックアウト時に必須項目のバリデーションを実行
 */

(function() {
  // ===========================================
  // 初期化関数
  // ===========================================
  
  function initShippingForms() {
    console.log('[Shipping Form] Initializing...');
    
    // すべての「異なる配送先」チェックボックスを取得
    const checkboxes = document.querySelectorAll('.cart-attribute__different-shipping-checkbox');
    console.log('[Shipping Form] Found checkboxes:', checkboxes.length);
    
    checkboxes.forEach(checkbox => {
      const lineIndex = checkbox.getAttribute('data-line-index');
      const shippingForm = document.getElementById(`ShippingForm-${lineIndex}`);
      
      if (!shippingForm) {
        console.warn(`[Shipping Form] Form not found for line ${lineIndex}`);
        return;
      }
      
      // 初期状態を設定
      if (checkbox.checked) {
        shippingForm.style.display = 'block';
      } else {
        shippingForm.style.display = 'none';
      }
      
      console.log(`[Shipping Form] Line ${lineIndex} initialized, checked: ${checkbox.checked}`);
    });
  }
  
  // ===========================================
  // イベント委譲方式でチェックボックスの変更を監視
  // ===========================================
  
  document.addEventListener('change', function(e) {
    // チェックボックスかどうか確認
    if (!e.target.classList.contains('cart-attribute__different-shipping-checkbox')) {
      return;
    }
    
    const checkbox = e.target;
    const lineIndex = checkbox.getAttribute('data-line-index');
    const shippingForm = document.getElementById(`ShippingForm-${lineIndex}`);
    
    if (!shippingForm) {
      console.warn(`[Shipping Form] Form not found for line ${lineIndex}`);
      return;
    }
    
    console.log(`[Shipping Form] Checkbox changed for line ${lineIndex}, checked: ${checkbox.checked}`);
    
    if (checkbox.checked) {
      shippingForm.style.display = 'block';
      // フォームが表示されたら最初の入力欄にフォーカス
      const firstInput = shippingForm.querySelector('input');
      if (firstInput) {
        setTimeout(() => firstInput.focus(), 100);
      }
    } else {
      shippingForm.style.display = 'none';
      // フォームが非表示になったら入力値をクリア
      clearShippingForm(lineIndex);
    }
  });
  
  // 配送先フォームの入力値をクリア
  function clearShippingForm(lineIndex) {
    const form = document.getElementById(`ShippingForm-${lineIndex}`);
    if (!form) return;
    
    form.querySelectorAll('input').forEach(input => {
      input.value = '';
      input.style.borderColor = '';
    });
    
    form.querySelectorAll('select').forEach(select => {
      select.selectedIndex = 0;
      select.style.borderColor = '';
    });
  }
  
  // ===========================================
  // 入力フィールドのリアルタイムバリデーション
  // ===========================================
  
  // フォーカスアウト時のバリデーション（イベント委譲）
  document.addEventListener('blur', function(e) {
    if (!e.target.classList.contains('shipping-required-field')) return;
    
    const field = e.target;
    const shippingSection = field.closest('.cart-attribute__different-shipping');
    if (!shippingSection) return;
    
    const checkbox = shippingSection.querySelector('.cart-attribute__different-shipping-checkbox');
    
    // チェックボックスがONの場合のみバリデーション
    if (checkbox && checkbox.checked) {
      if (!field.value.trim()) {
        field.style.borderColor = '#dc3545';
      } else {
        field.style.borderColor = '#28a745';
      }
    }
  }, true);
  
  // 入力時にエラー表示をクリア（イベント委譲）
  document.addEventListener('input', function(e) {
    if (!e.target.classList.contains('shipping-required-field')) return;
    
    if (e.target.value.trim()) {
      e.target.style.borderColor = '';
    }
  });
  
  // ===========================================
  // 郵便番号からの住所自動入力
  // ===========================================
  
  document.addEventListener('blur', async function(e) {
    // 郵便番号フィールドかどうか確認
    if (!e.target.name || !e.target.name.includes('郵便番号')) return;
    
    const postalInput = e.target;
    const postalCode = postalInput.value.replace(/-/g, '');
    
    if (postalCode.length !== 7) return;
    
    try {
      // 郵便番号APIを使用
      const response = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${postalCode}`);
      const data = await response.json();
      
      if (data.results && data.results.length > 0) {
        const result = data.results[0];
        const lineIndex = postalInput.getAttribute('data-line-index');
        
        // 都道府県を設定
        const prefectureSelect = document.getElementById(`ShippingPrefecture-${lineIndex}`);
        if (prefectureSelect) {
          prefectureSelect.value = result.address1;
        }
        
        // 住所を設定（市区町村 + 町域）
        const addressInput = document.getElementById(`ShippingAddress-${lineIndex}`);
        if (addressInput) {
          addressInput.value = result.address2 + result.address3;
          addressInput.focus();
        }
        
        console.log(`[Shipping Form] Address auto-filled for line ${lineIndex}`);
      }
    } catch (error) {
      console.log('[Shipping Form] Failed to fetch address from postal code:', error);
    }
  }, true);
  
  // ===========================================
  // 初期化実行
  // ===========================================
  
  // DOMContentLoaded または即時実行
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initShippingForms);
  } else {
    // DOMは既に読み込み済み
    initShippingForms();
  }
  
  console.log('[Shipping Form] Script loaded');
})();